var exports = {
  "W": "MetadataFooterLoadingContainer__aPAJG7",
};

module.exports = exports;
